module.exports = __webpack_public_path__ + "static/media/vertical_com_fotos_conteudos.05ab0730.jpg";